import pl from './pl_PL.json'
import en from './en_EN.json'
import {getLocale} from "libs/locale";


const Tr = (key, obj, translateObj = false) => {
    const localeTr = getLocale() === "en_EN" ? en : pl;

    let tr = localeTr[key];
    if (tr === undefined) {
        if (process.env.NODE_ENV === 'development') {
            console.warn(`Key "${key}" not exist in translation`);
        }
        return key
    }
    if (obj) {
        for (let k in obj) {
            const find = `{{${k}}}`
            tr = tr.replace(new RegExp(find, 'g'), translateObj ? Tr(obj[k]) : obj[k])
        }
    }
    return tr;
};
export default Tr;